// extracted by mini-css-extract-plugin
export default {"card":"EpisodeCard_card__Jc3My","info":"EpisodeCard_info__xv93T","button":"EpisodeCard_button__tlmTq"};